import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import {Provider} from "react-redux"
import App from "./App";
import store from './store/store' ;
import ToastConfig from './config/toastConfig';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
  <Provider store={store}>
  <App />
  {/* import toast component */}
  <ToastConfig />
  </Provider>
   
  </BrowserRouter>
);